import script from "./libraries.vue?vue&type=script&setup=true&lang=ts"
export * from "./libraries.vue?vue&type=script&setup=true&lang=ts"

import "./libraries.vue?vue&type=style&index=0&id=af1b7cfe&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-af1b7cfe"]])

export default __exports__